import { Flex } from "@mantine/core";
import Container from "../components/common/Container";
import TodayShifts from "../components/Dashboard/TodayShifts";
import UpcomingBirthdays from "../components/Dashboard/UpcomingBirthdays";
import WeeklyAttendanceAnalysis from "../components/Dashboard/WeeklyAttendanceAnalysis";
import LiveActivity from "../components/Dashboard/LiveActivity";
import Filters from "../components/Dashboard/Filters";
import InfoBoxes from "../components/Dashboard/InfoBoxes";
import MissingToday from "../components/Dashboard/MissingToday";
import { FilterProvider } from "../context/DashboardFilterContext";
import WorkDurationCard from "../components/Dashboard/Workdurationcard";
import InsideNow from "../components/Dashboard/InsideNow";
import PendingNotices from "../components/Dashboard/PendingNotices";
import RotationToday from "../components/Dashboard/RotationToday";

/**
 * ÖZET RAPOR.
 *
 * Satırlar SABİT yükseklikliydi (h={84}/{320}/{476}) ve içleri iki sütuna
 * bölünüyordu. Dar ekranda içerik dikeye dizilince kutunun içine sığmıyor,
 * kartlar üst üste biniyordu — telefonda ilk açılan sayfa buydu. Mantine'in
 * duyarlı prop'larıyla ≤1024'te satırlar dikeye dönüyor ve yükseklik içeriğe
 * bırakılıyor (kırılım noktaları index.tsx'te theme.ts ile hizalandı).
 */
const Dashboard = () => {
  return (
    <FilterProvider>
      <Container>
        <Flex gap={22} direction="column">

          <Flex h={{ base: "auto", md: 84 }} align="stretch">
            <Filters flex={1} />
          </Flex>

          {/*
            Bekleyen çalışan bildirimleri EN ÜSTTE (plan 2.59): bu bir uyarı
            yüzeyi, bir rapor değil — İK'nın "bakılacak bir şey var mı"
            sorusunu sayfaya girer girmez cevaplaması gerekiyor. Yükseklik
            içeriğe bırakıldı: bekleyen yokken tek satır kalıyor, kalabalık
            yapmıyor.
          */}
          <Flex h="auto" align="stretch">
            <PendingNotices flex={1} />
          </Flex>

          <Flex
            gap={20}
            h={{ base: "auto", md: 320 }}
            direction={{ base: "column", md: "row" }}
            align="stretch"
          >
            <InfoBoxes flex={1} />
            <TodayShifts flex={1} />
          </Flex>

          {/*
            Rota özeti "Bugünün Vardiyaları"nın hemen altında: ikisi de BUGÜN'ü
            anlatıyor ama farklı şeyi — o kart takvimden atanan somut
            vardiyaları, bu kutu hesaplanan çevrimi gösteriyor (plan 2.62).
            Yükseklik içeriğe bırakıldı: ekip sayısı kadar satır.
          */}
          <Flex h="auto" align="stretch">
            <RotationToday flex={1} />
          </Flex>

          <Flex h={{ base: "auto", md: 476 }} gap={20} align="stretch">
            <LiveActivity flex={1} />
          </Flex>

          {/*
            "Şu An Binada" ile "Henüz Gelmeyenler" tamamlayıcı iki soru, o yüzden
            yan yana (plan 2.32). İkisi de aynı satır bileşenini kullanıyor;
            1:1 bölüşümde ikisi de eski `MissingToday` genişliğinden GENİŞ
            kalıyor, yani mevcut kutu daralmıyor.
          */}
          <Flex
            h={{ base: "auto", md: 476 }}
            gap={20}
            direction={{ base: "column", md: "row" }}
            align="stretch"
          >
            <InsideNow flex={1} />
            <MissingToday flex={1} />
          </Flex>

          <Flex
            h={{ base: "auto", md: 412 }}
            gap={20}
            direction={{ base: "column", md: "row" }}
            align="stretch"
          >
            <WeeklyAttendanceAnalysis flex={5} />
            <UpcomingBirthdays flex={4} />
          </Flex>

          <Flex gap={20} mih={{ base: "auto", md: 480 }} align="stretch">
            <WorkDurationCard flex={1} />
          </Flex>

        </Flex>
      </Container>
    </FilterProvider>
  );
};

export default Dashboard;